export default __webpack_public_path__ + "assets/icons/gift-from-bob-icon.9e4f4e27f93142f6e6d6d8bbd3aa7647.svg";